import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type NotificationType = 'success' | 'error';

export interface AppNotification {
  type?: NotificationType;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private state$ = new BehaviorSubject<AppNotification>(null);

  get notification$() {
    return this.state$.asObservable();
  }

  show(notification: AppNotification) {
    this.state$.next(notification);
  }

  clean() {
    if (this.state$.value != null) {
      this.state$.next(null);
    }
  }
}
